export default __webpack_public_path__ + "images/BE.7f7acb5.png";